// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4683":"dcdb8afc","6557":"03ee9832"}[chunkId] + ".chunk.css";
};